import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import CookieBanner from './sharable-components/CookieBanner/CookieBanner';
import { Routes } from './routes/routes';
import { handleOrderRequest, handleLanguageParameter } from './common/js/urlRequest';
import useAppState from './hooks/useAppState';
import BusyModeOnboarding from './sharable-components/Onboarding/BusyModeOnboarding';
import { useIsAuthenticated } from '@lo/shared/store/auth';
import { useWindowSize } from './hooks/useWindowSize';
import { useToasterBottomOffset } from '@lo/shared/store/toaster';
import 'react-toastify/dist/ReactToastify.css';
import './index.scss';

const App: React.FC = () => {
    const location = useLocation();
    const isAuthenticated = useIsAuthenticated();
    const { isLessThanTabletWidth } = useWindowSize();
    const toasterBottomOffset = useToasterBottomOffset();
    useAppState();

    useEffect(() => {
        handleOrderRequest(location);
        handleLanguageParameter(location);
    }, []);

    return (
        <>
            <ToastContainer
                enableMultiContainer
                containerId="generalNotifications"
                style={{ bottom: isLessThanTabletWidth ? toasterBottomOffset : 0 }}
            />
            <Routes />
            <CookieBanner />
            {isAuthenticated && <BusyModeOnboarding />}
        </>
    );
};

export default App;
